module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_5012.42282b63.png";